import { ProducClickForBrandPageParameters } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductLink/Brand/ProductLinkForBrandPageProps";
import { useOnProductClickBase } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/productTileActions/useOnProductClickBase";
import { useBrandProductResultData } from "@faire/retailer/views/brand/hooks/useBrandProductResultData";

export const useOnProductClickForBrandPage = (
  params: ProducClickForBrandPageParameters
) => {
  const productsQueryData = useBrandProductResultData();
  const showVerticalImagery =
    params.showVerticalImagery ?? productsQueryData.showVerticalImagery;

  const onProductClick = useOnProductClickBase({
    ...params,
    showVerticalImagery,
  });
  return onProductClick;
};
